import template from './single-select-dropdown.html';
class SingleSelectController {
  constructor() {
    this.isDropdownOpen = false;
    this.selectedOption = '';
    this.filterOptions = [];
  }
  $onChanges() {
    this.filterName = this.filterName || '';
    this.filterOptions = this.options || [];
    this.label = this.label || this.filterPrompt;
  }

  // Functions

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectionChanged(option) {
    const { label = '' } = option;
    this.selectedOption = label;
    this.selectionChange({ parameterObject: { name: this.filterName, value: label } });
    this.toggleDropdown();
  }
}

export default {
  template,
  controller: SingleSelectController,
  controllerAs: 'vm',
  bindings: {
    filterName: '@',
    filterPrompt: '@',
    translateValues: '<?',
    label: '@',
    options: '<',
    selectionChange: '&',
  },
};
